// 修改 maskScroll.js 文件
export default {
  inserted(el, binding) {
    // binding.value 可以是一个对象，包含多个属性和方法
    if (binding.value && binding.value.enabled) {
      applyMask(el, binding.value);
    }
  },
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      if (binding.value && binding.value.enabled) {
        applyMask(el, binding.value);
      } else {
        removeMask(el);
      }
    }
  },
  unbind(el) {
    removeMask(el);
  }
};

function applyMask(el, options = {}) {
  // 移除已存在的遮罩层（如果有）
  removeMask(el);
  
  // 创建遮罩层
  const mask = document.createElement('div');
  mask.className = 'vue-mask-scroll';
  mask.style.cssText = `
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    background-color: transparent;
    pointer-events: auto;
  `;
  
  // 阻止点击事件并调用传入的方法
  mask.addEventListener('click', (e) => {
    e.stopPropagation();
    e.preventDefault();
    
    // 调用传入的点击处理方法
    if (typeof options.onClick === 'function') {
      options.onClick(e);
    }
  });
  
  // 如果有自定义的触摸事件处理
  if (typeof options.onTouchMove === 'function') {
    mask.addEventListener('touchmove', options.onTouchMove, { passive: true });
  }
  
  // 保存引用以便后续移除
  el._maskElement = mask;
  el._maskOptions = options; // 保存选项以便后续使用
  
  // 设置容器样式以确保正确的定位上下文
  const currentPosition = window.getComputedStyle(el).position;
  if (currentPosition === 'static') {
    el.style.position = 'relative';
  }
  
  // 添加遮罩层
  el.appendChild(mask);
  
  // 添加滚动事件监听，确保遮罩层覆盖整个滚动区域
  const updateMaskSize = () => {
    // 获取元素的滚动高度
    const scrollHeight = el.scrollHeight;
    const scrollWidth = el.scrollWidth;
    
    // 更新遮罩层尺寸，确保覆盖整个可滚动区域
    mask.style.height = `${scrollHeight}px`;
    mask.style.width = `${scrollWidth}px`;
  };
  
  // 初始更新尺寸
  updateMaskSize();
  
  // 监听滚动事件
  el._scrollHandler = () => {
    updateMaskSize();
  };
  
  el.addEventListener('scroll', el._scrollHandler, { passive: true });
  
  // 监听窗口大小变化
  el._resizeHandler = () => {
    updateMaskSize();
  };
  
  window.addEventListener('resize', el._resizeHandler, { passive: true });
}

function removeMask(el) {
  if (el._maskElement) {
    // 移除所有事件监听器
    if (el._maskOptions) {
      if (typeof el._maskOptions.onClick === 'function') {
        el._maskElement.removeEventListener('click', el._maskOptions.onClick);
      }
      if (typeof el._maskOptions.onTouchMove === 'function') {
        el._maskElement.removeEventListener('touchmove', el._maskOptions.onTouchMove);
      }
    }
    
    // 移除滚动和调整大小的事件监听器
    if (el._scrollHandler) {
      el.removeEventListener('scroll', el._scrollHandler);
      delete el._scrollHandler;
    }
    
    if (el._resizeHandler) {
      window.removeEventListener('resize', el._resizeHandler);
      delete el._resizeHandler;
    }
    
    el.removeChild(el._maskElement);
    delete el._maskElement;
    delete el._maskOptions;
  }
}